// Demo site's CSS
import fonts from './sass/fonts.scss';

import helpers from './sass/mixins/helpers.sass';

import bem from './sass/mixins/bem.sass';
import helpers from './sass/mixins/helpers.sass';




import demoStyle from './demo/sass/style.sass';

var location = window.location.pathname;
var directoryPath = location.substring(0, location.lastIndexOf("/")+1);


const overlay = document.getElementById('demo-overlay');
const highlightElement = Array.prototype.slice.call(document.getElementsByClassName('overlayHighlight'));


window.toggleOverlay = function toggleOverlay(e){
  e.target.classList.toggle('m-active') // Toggle slider background
  e.target.children[0].classList.toggle('m-active') // Toggle slider
  overlay.classList.toggle('m-active'); // Toggle overlay

  // Toggle all elements who should be seen over overlay
  highlightElement.forEach( elem => {
    elem.classList.toggle('m-active'); 
    showTooltipForElem(elem);
  });
}

let tooltip;

function showTooltipForElem(elem){
  tooltip = elem.querySelector('.tooltip');
  tooltip.classList.toggle('m-active'); 
}



// WEBPACK FOOTER //
// ./demoSite.js